// Generated by Melange

import * as Curry from "melange.js/curry.js";
import * as Melange__CompHeader from "./CompHeader.js";
import * as Melange__CompPilots from "./CompPilots.js";
import * as Melange__CompSettings from "./CompSettings.js";
import * as Melange__CompTabs from "./CompTabs.js";
import * as Melange__CompTasks from "./CompTasks.js";
import * as Melange__Comps from "./Comps.js";
import * as Melange__Types from "./Types.js";
import * as ReasonReactRouter from "reason-react/ReasonReactRouter.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function App$Breadcrumb(Props) {
  let compName = Props.compName;
  return JsxRuntime.jsx("nav", {
    children: JsxRuntime.jsxs("ul", {
      children: [
        JsxRuntime.jsx("li", {
          children: JsxRuntime.jsx("a", {
            children: "King Post (ReasonML)",
            href: "/"
          })
        }),
        JsxRuntime.jsx("li", {
          children: compName,
          className: "is-active"
        })
      ]
    }),
    className: "breadcrumb"
  });
}

const Breadcrumb = {
  make: App$Breadcrumb
};

function App$Spacer(Props) {
  return JsxRuntime.jsx("div", {
    className: "spacer"
  });
}

const Spacer = {
  make: App$Spacer
};

function App(Props) {
  const url = ReasonReactRouter.useUrl(undefined, undefined);
  const match = React.useState(function () {
    return "";
  });
  const setCompUrl = match[1];
  const compUrl = match[0];
  const match$1 = React.useState(function () {
    return Melange__Types.nullComp;
  });
  const setComp = match$1[1];
  const comp = match$1[0];
  const match$2 = React.useState(function () {
    return Melange__Types.nullNominals;
  });
  const setNominals = match$2[1];
  const nominals = match$2[0];
  const match$3 = React.useState(function () {
    return [];
  });
  const setTaskLengths = match$3[1];
  const match$4 = React.useState(function () {
    return [];
  });
  const setCompTasks = match$4[1];
  const compTasks = match$4[0];
  const match$5 = React.useState(function () {
    return [];
  });
  const setCompPilots = match$5[1];
  const haveCompUrl = compUrl !== "";
  React.useEffect((function () {
    const match = url.path;
    if (match && match.hd === "comp-prefix") {
      const match$1 = match.tl;
      if (match$1 && !match$1.tl) {
        const compPrefix = match$1.hd;
        Curry._1(setCompUrl, (function (param) {
          return "http://" + (compPrefix + ".flaretiming.com/json");
        }));
        ReasonReactRouter.push("/comp");
      }
      
    }
    
  }), [
    url,
    setCompUrl
  ]);
  React.useEffect((function () {
    Melange__Types.getComp(haveCompUrl, compUrl, setComp);
  }), [
    haveCompUrl,
    compUrl,
    setComp
  ]);
  React.useEffect((function () {
    Melange__Types.getNominals(haveCompUrl, compUrl, setNominals);
  }), [
    haveCompUrl,
    compUrl,
    setNominals
  ]);
  React.useEffect((function () {
    Melange__Types.getTaskLengths(haveCompUrl, compUrl, setTaskLengths);
  }), [
    haveCompUrl,
    compUrl,
    setTaskLengths
  ]);
  React.useEffect((function () {
    Melange__Types.getCompTasks(haveCompUrl, compUrl, setCompTasks);
  }), [
    haveCompUrl,
    compUrl,
    setCompTasks
  ]);
  React.useEffect((function () {
    Melange__Types.getCompPilots(haveCompUrl, compUrl, setCompPilots);
  }), [
    haveCompUrl,
    compUrl,
    setCompPilots
  ]);
  const match$6 = url.path;
  if (!match$6) {
    return JsxRuntime.jsx(Melange__Comps.make, {});
  }
  switch (match$6.hd) {
    case "comp" :
      if (!match$6.tl) {
        return JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(App$Spacer, {}),
            JsxRuntime.jsx(Melange__CompHeader.make, {
              comp: comp,
              nominals: nominals
            }),
            JsxRuntime.jsx(App$Spacer, {}),
            JsxRuntime.jsx(App$Breadcrumb, {
              compName: comp.compName
            }),
            JsxRuntime.jsx(Melange__CompTabs.make, {}),
            JsxRuntime.jsx(Melange__CompTasks.make, {
              compTasks: compTasks,
              taskLengths: match$3[0]
            })
          ]
        });
      }
      break;
    case "comp-prefix" :
      const match$7 = match$6.tl;
      if (match$7 && !match$7.tl) {
        return JsxRuntime.jsx("div", {});
      }
      break;
    case "pilots" :
      if (!match$6.tl) {
        return JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(App$Spacer, {}),
            JsxRuntime.jsx(Melange__CompHeader.make, {
              comp: comp,
              nominals: nominals
            }),
            JsxRuntime.jsx(App$Spacer, {}),
            JsxRuntime.jsx(App$Breadcrumb, {
              compName: comp.compName
            }),
            JsxRuntime.jsx(Melange__CompTabs.make, {}),
            JsxRuntime.jsx(Melange__CompPilots.make, {
              tasks: compTasks,
              pilots: match$5[0]
            })
          ]
        });
      }
      break;
    case "settings" :
      if (!match$6.tl) {
        return JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(App$Spacer, {}),
            JsxRuntime.jsx(Melange__CompHeader.make, {
              comp: comp,
              nominals: nominals
            }),
            JsxRuntime.jsx(App$Spacer, {}),
            JsxRuntime.jsx(App$Breadcrumb, {
              compName: comp.compName
            }),
            JsxRuntime.jsx(Melange__CompTabs.make, {}),
            JsxRuntime.jsx(Melange__CompSettings.make, {
              giveFraction: comp.give.giveFraction,
              earthRadius: comp.earth.sphere.radius,
              earthMath: comp.earthMath
            })
          ]
        });
      }
      break;
  }
  return JsxRuntime.jsx("div", {
    children: "Route not found"
  });
}

const make = App;

export {
  Breadcrumb,
  Spacer,
  make,
}
/* Melange__CompHeader Not a pure module */
